import React from 'react';

const Arrow = ({
  diagonal = false,
  ...props
}) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" {...props}>{diagonal ? <path d="M5 19 19 5M5 5h14v14" /> : <path d="M4 12h15m-6-6 6 6-6 6" />}</svg>;

function TechnicalIcon({
  type
}) {
  return <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.25" aria-hidden="true">{type === 'schedule' ? <><path d="M10 14h44v40H10zM10 24h44M20 9v10M44 9v10M18 32h12v6H18zm16 10h12v6H34z" /><path d="M30 35h9v7" /></> : type === 'mine' ? <><path d="m5 47 17-30 12 21 8-14 17 28H5M13 52l11-19 11 19M29 29l5 9m8-14 3 15 6 1" /><path d="M8 58h48M31 10v9m-5-4h10" /></> : <><path d="M12 9h29l10 10v36H12zM41 9v12h10M20 29h17M20 35h10M20 45l6-5 8 5 10-12" /><circle cx="44" cy="33" r="3" /></>}</svg>;
}

export { Arrow, TechnicalIcon };
